import React from "react";
import { Link } from "react-router-dom";

export default function ProductCard({ product, idx = 0 }) {
  return (
    <Link
      to={`/product/${product.id}`}
      data-testid={`product-card-${product.id}`}
      className="product-card group block fade-in-up"
      style={{ animationDelay: `${0.05 * (idx % 6)}s` }}
    >
      <div className="aspect-[3/4] overflow-hidden bg-alimi-surface2">
        {product.images?.[0] ? (
          <img
            src={product.images[0]}
            alt={product.name}
            className="w-full h-full object-cover"
            loading="lazy"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-alimi-inkSoft text-xs">
            Senza immagine
          </div>
        )}
      </div>
      <div className="pt-5 pb-3 px-1">
        <div className="overline text-[0.6rem]">{product.category}</div>
        <div className="font-serif text-lg mt-2 text-alimi-ink">{product.name}</div>
        <div className="text-sm text-alimi-inkSoft mt-1">€ {Number(product.price).toFixed(2)}</div>
      </div>
    </Link>
  );
}
